/**
 * Created by qx on 2018/12/31.
 */
/*广告主和KA广告主的计划管理 接口接入*/
import axios from 'axios';
import { BASE_URL } from '@/global/util/constants';
import qs from 'qs';

const getters = {};

const actions = {
  async orderItem({ state, commit }, { platform, data }) {
    // 获取通某用列表数据
    let response = await axios.get(`${BASE_URL}/interface/etcd/item/` + data + '?platform=' + platform);
    return response.data;
  },
  async orderNameIsRepeat({ state, commit }, { platform, data }) {
    let response = await axios.get(`${BASE_URL}/${platform}/order/is-repeated/` + data);
    return response.data;
  },
  async adPlace({ state, commit }, { platform, data }) {
    let response = await axios.get(`${BASE_URL}/${platform}/order/place`, { params: data });
    return response.data;
  },
  async someItem({ state, commit }, { params, data }) {
    // 终端，支付方式
    let response = await axios.get('/interface/etcd/item/' + params, data);
    return response;
  },
  async orderList({ state, commit }, { platform, data }) {
    // 计划列表 / 查看计划
    let response;
    if (data && data.orderId) {
      response = await axios.get(`${BASE_URL}/${platform}/order/` + data.orderId);
    } else {
      response = await axios.get(`${BASE_URL}/${platform}/order`, { params: data });
    }
    return response.data;
  },
  async addOrder({ state, commit }, { platform, data }) {
    // 添加计划
    let response = await axios.post(`${BASE_URL}/${platform}/order`, data);
    return response.data;
  },
  async updateOrder({ state, commit }, { platform, data, id }) {
    // 更新计划
    let response = await axios.put(`${BASE_URL}/${platform}/order/${id}`, data);
    return response.data;
  },
  async stopOrder({ state, commit }, { platform, data }) {
    // 停止计划
    let response = await axios.get(`${BASE_URL}/${platform}/order/stop/` + data.id);
    return response.data;
  },
  async switchOrder({ state, commit }, { platform, data }) {
    // 改变计划状态
    let response = await axios.get(`${BASE_URL}/${platform}/order/change-status/` + data.id);
    return response.data;
  },
  async batchOpen({ state, commit }, { platform, data }) {
    // 批量启动
    let response = await axios.post(`${BASE_URL}/${platform}/order/batch-begin`, data);
    return response.data;
  },
  async batchPause({ state, commit }, { platform, data }) {
    // 批量暂停
    let response = await axios.post(`${BASE_URL}/${platform}/order/batch-pause`, data);
    return response.data;
  }
};

const mutations = {};

export default {
  getters,
  actions,
  mutations
};
